export const SLOW_RESPONDER_HOURS_THRESHOLD = 24;
export const REVIEW_BOOKING_UPDATES_PAGE_SIZE = 25;
/**
 * Threads to fetch for the requests-and-inquiries card so we can dedupe by
 * listing and stack up to `MAX_LISTING_THUMBNAILS` thumbnails. Needs to be
 * larger than the cap to give us a chance of finding distinct listings.
 */
export const BOOKING_REQUESTS_AND_INQUIRIES_PAGE_SIZE = 10;
/** Max listing thumbnails the requests-and-inquiries card will stack. */
export const MAX_LISTING_THUMBNAILS = 3;
/** Show the unread-messages card whenever the host has at least one unread thread. */
export const UNREAD_MESSAGES_MIN_COUNT = 1;
